import { render, staticRenderFns } from "./LegalPageForm.vue?vue&type=template&id=33ba079c&"
import script from "./LegalPageForm.vue?vue&type=script&lang=js&"
export * from "./LegalPageForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports